import axios from 'axios'
import Cookies from 'vue-cookies'

// axios.defaults.baseURL = '/site/'
axios.defaults.baseURL = '/pingansec/site/'
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'// 配置请求头
// http request 拦截器
const instance = axios.create()
instance.interceptors.request.use(
  config => {
    let user = Cookies.get('user')
    let token = user ? user.token : ''
    if (token) {
      config.headers.common['token'] = token
    }
    return config
  }
)

export default instance



// WEBPACK FOOTER //
// ./src/assets/js/http.js